/**
 * Whether an in-flight stream still owns the session's live `streamingAnswer`.
 *
 * After a turn settles, the message queue (and fast follow-ups) can start the
 * next send while the previous NDJSON/WS loop is still flushing a final
 * `_activities` snapshot. Without this check those late writes land on the
 * new turn's bubble (e.g. sharks briefly shows tulips' Activity History count).
 *
 * Legacy responses without `turn_id` keep the previous permissive behavior.
 */
export function streamOwnsStreamingSlot(
  streamTurnId: string | undefined,
  liveStreamingTurnId: string | undefined
): boolean {
  if (streamTurnId == null || liveStreamingTurnId == null) return true
  return streamTurnId === liveStreamingTurnId
}
